import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useMemo } from 'react';
import { buildStationRangeHlsUrl } from '../../../helpers/build-station-range-hls-url';
import { useStreamSegmentsRange } from '../../../hooks/segments/useStreamSegmentsQuery';

//const MOCKED_LOGGER_HLS_URL = 'http://127.0.0.1:8787/case-2/original.hls';
const MOCKED_LOGGER_HLS_URL = undefined;

/**
 * Returns the HLS source URL for the logger video player.
 * Uses the current station and stream segments range. Adds 1 ms to the from
 * timestamp so the API does not return the previous segment.
 */
export function useLoggerVideoSrc() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange()!;

  return (
    MOCKED_LOGGER_HLS_URL ??
    useMemo(
      () => buildStationRangeHlsUrl(station.id, range.from, range.to),
      [station.id, range.from, range.to],
    )
  );
}
